import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { Input } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { UserConsumer } from "../../../UserContext";

function FilterationBar(props) {
  const {
    supervisorsEmpList,
    selectedSupEmpList,
    onSupEmpChange,
    className,
    isActive,
    onActiveChange,
  } = props;

  return (
    <UserConsumer>
      {(userDetails) => {
        return (
          <Row className={`filterationBar ${className}`}>
            <Col lg={6}>
              <Form.Group className="input-field">
                <Form.Label className="label">Select The Employee</Form.Label>
                <Col>
                  <CustomReactSelect
                    options={supervisorsEmpList}
                    value={selectedSupEmpList}
                    onChange={(value) => onSupEmpChange(value)}
                  />
                </Col>
              </Form.Group>
            </Col>
            {userDetails.empRole.includes("3") && (
              <Col>
                <Form.Group className="input-field mt-1">
                  <Form.Label className="label">Active</Form.Label>
                  <Col>
                    <Input
                      className="ml-2 checkboxInput"
                      type="checkbox"
                      value={isActive}
                      onChange={() => onActiveChange()}
                    />
                  </Col>
                </Form.Group>
              </Col>
            )}
          </Row>
        );
      }}
    </UserConsumer>
  );
}

export default FilterationBar;
